import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { getDeepCopyOfObject } from 'app/shared/utilities/utility-methods.utility';
import { FilterItemInterface } from 'app/site-filters/models';
// imported cookie service
import { CookieService } from 'ngx-cookie-service';

import { FilterInterface } from '../../models/filter.model';



@Component({
  selector: 'cz-site-filter-menu',
  templateUrl: './site-filter-menu.component.html',
  styleUrls: ['./site-filter-menu.component.scss'],
})
export class SiteFilterMenuComponent implements OnInit {
  public shouldDisplay: boolean;
  public filterBtnActive: boolean;
  public activeItemCount: number = 0;
  public filterItemForm: FormGroup;
  public itemSearchControl: FormControl;
  // boolean variable delaration
  public isSpanish: boolean = false;

  @Input() public filterMenuData: FilterInterface;
  @Output() public getUpdateFilterData: EventEmitter<FilterInterface> = new EventEmitter<FilterInterface>();
  @ViewChild(MatMenuTrigger) public trigger: MatMenuTrigger;

  constructor(private _formBuilder: FormBuilder, private readonly _cookieService: CookieService) {
    // checking condition for culture(cookie) value is french to update boolean value
    if (this._cookieService.get('Culture') !== 'en') {
      this.isSpanish = true;
    }
    this.itemSearchControl = new FormControl('');
  }

  public ngOnInit(): void {
    if(this.filterMenuData && this.filterMenuData.items && this.filterMenuData.items.length > 0) {
      this.shouldDisplay = true;
      this.filterItemForm = this._formBuilder.group(this.createFilterFormControls(this.filterMenuData.items));
      this.setInitialFilterState(this.filterMenuData.items);


      this.activeItemCount = this.countActiveFilters(this.filterMenuData.items);
      if(this.activeItemCount > 0) {
        this.filterBtnActive = true;
      }
    }
  }

  // Closes a filter menu "X"
  public closeFilterMenu(): void {

    this.setInitialFilterState(this.filterMenuData.items);

    this.activeItemCount = this.countActiveFilters(this.filterMenuData.items);
    if(this.activeItemCount > 0) {
      this.filterBtnActive = true;
    }

    this.trigger.closeMenu();
  }

  public clearallFilter(): void {
    const filterUpdateData: FilterInterface = getDeepCopyOfObject(this.filterMenuData);

    filterUpdateData.items.forEach((filterItem: FilterItemInterface) => {
      filterItem.isSelected = false;
      this.filterItemForm.get(filterItem.id.toString()).setValue(false);
    });

    this.activeItemCount = 0;
    this.filterBtnActive = false;
    filterUpdateData.isSelected = false;

    this.getUpdateFilterData.emit(filterUpdateData);

    this.trigger.closeMenu();
  }

  public customFilterActive(): void {
    const filterUpdateData: FilterInterface = getDeepCopyOfObject(this.filterMenuData);

    filterUpdateData.items.forEach((filterItem: FilterItemInterface) => {
      filterItem.isSelected = this.filterItemForm.get(filterItem.id.toString()).value;
    });

    this.activeItemCount = this.countActiveFilters(filterUpdateData.items);
    if(this.activeItemCount > 0) {
      this.filterBtnActive = true;
      filterUpdateData.isSelected = true;
    } else {
      this.filterBtnActive = false;
      filterUpdateData.isSelected = false;
    }

    this.getUpdateFilterData.emit(filterUpdateData);

    this.trigger.closeMenu();
  }

  private countActiveFilters(filterItems: FilterInterface[]): number {
    return filterItems.filter((filterItem: FilterItemInterface) => {
      return filterItem.isSelected;
    }).length;
  }

  private setInitialFilterState(filterItems: FilterInterface[]): void {
    filterItems.forEach((filterItem: FilterItemInterface) => {
      this.filterItemForm.get(filterItem.id.toString()).setValue(filterItem.isSelected);
    });
  }

  private createFilterFormControls(filterItems: FilterItemInterface[]): {} {
    const group: { [id: number ]: FormControl } = {};

    if(!filterItems) { return group; }

    filterItems.forEach((filterItem: FilterItemInterface) => {
      group[filterItem.id] = new FormControl(false);
    });

    return group;
  }
}
